import * as React from "react";
import { styled } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import clsx from "clsx";
import { DemoBadge } from "./demoPanelTooltip";

//region [[ Styles ]]
const InChatDemoReasoningIconContainer = styled("div")({
  display: "inline-flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
  margin: "0 5px",
});

const IconContainer = styled("div")({
  maxWidth: "65px",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
  flexFlow: "column",
});

const InChatDemoReasoningIconView = styled(IconButton)({
  "&.in-chat-reasoning-icon, &.in-chat-reasoning-icon:hover, &.in-chat-reasoning-icon:focus": {
    margin: "5px",
    background: "rgba(254, 183, 0, 1)",
    color: "#8E6600",
    fontSize: "10px",
    padding: "6px 10px",
    fontWeight: 900,
    maxHeight: "28px",
    "&:hover": {
      background: "rgba(254, 183, 0, 1)",
    },
  },
});
export const InChatReasoningButtonBadge = styled(DemoBadge)({
  "&.reasoning-text, &.reasoning-text:hover, &.reasoning-text:active, &.reasoning-text:focus": {
    color: " #8E6600",
    margin: 0,
    padding: "2px 5px",
    fontSize: "8px",
    textTransform: "none",
    borderRadius: "6px",
    backgroundColor: "#FEB700",
    width: "100%",
    textAlign: "center",
  },
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface InChatDemoReasoningIconProps {
  className?: string;
  onClick?: (e) => void;
  disabled?: boolean;
  noBadge?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const InChatDemoReasoningIcon = ({
  ...props
}: InChatDemoReasoningIconProps) => {
  return (
    <InChatDemoReasoningIconContainer>
      <IconContainer>
        <InChatDemoReasoningIconView
          onClick={props.onClick}
          disabled={props.disabled}
          className={clsx(props.className, "in-chat-reasoning-icon")}
        >
          ?
        </InChatDemoReasoningIconView>
        {!props.noBadge && (
          <InChatReasoningButtonBadge
            className={"reasoning-text"}
            onClick={props.onClick}
            disabled={props.disabled}
          >
            Clinical Reasoning
          </InChatReasoningButtonBadge>
        )}
      </IconContainer>
    </InChatDemoReasoningIconContainer>
  );
};
